import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'Sobre', id: 'sobre' },
    { label: 'Para Quem', id: 'para-quem' },
    { label: 'Áreas', id: 'areas' },
    { label: 'Metodologia', id: 'metodologia' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contato', id: 'contato' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <img
              src={isScrolled
                ? "https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                : "https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/b419316c95e6a3838b430df11e66a3af.png"
              }
              alt="AAPEQ - Primordial Artista Energy"
              className={isScrolled ? "h-10 w-auto" : "h-12 w-auto"}
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('sobre')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('para-quem')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              Para Quem É
            </button>
            <button
              onClick={() => scrollToSection('areas')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              Áreas de Atuação
            </button>
            <button
              onClick={() => scrollToSection('metodologia')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              Metodologia
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contato
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('sobre')}
                className="text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors text-left px-4 cursor-pointer"
              >
                Sobre
              </button>
              <button
                onClick={() => scrollToSection('para-quem')}
                className="text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors text-left px-4 cursor-pointer"
              >
                Para Quem É
              </button>
              <button
                onClick={() => scrollToSection('areas')}
                className="text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors text-left px-4 cursor-pointer"
              >
                Áreas de Atuação
              </button>
              <button
                onClick={() => scrollToSection('metodologia')}
                className="text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors text-left px-4 cursor-pointer"
              >
                Metodologia
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all mx-4 cursor-pointer"
              >
                Contato
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
